const map = {
	"./cs": 4540,
	"./cs.json": 4540,
	"./da": 9593,
	"./da.json": 9593,
	"./de": 6477,
	"./de.json": 6477,
	"./en": 5553,
	"./en.json": 5553,
	"./es": 325,
	"./es.json": 325,
	"./fr": 4554,
	"./fr.json": 4554,
	"./it": 6851,
	"./it.json": 6851,
	"./nl": 6164,
	"./nl.json": 6164,
	"./pl": 3638,
	"./pl.json": 3638,
	"./pt": 4606,
	"./pt.json": 4606,
	"./pt_BR": 9175,
	"./pt_BR.json": 9175,
	"./sk": 647,
	"./sk.json": 647,
	"./sv": 6643,
	"./sv.json": 6643
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8469;